function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, CallToAction, Container, EntryAnimation, Heading, Label } from '../../atoms';
import { useAccentColors } from '../../hooks';
import { changeColorVariableWeight } from '../../utils';
export default function ArticleHero(param) {
    var _param_alignment = param.alignment, alignment = _param_alignment === void 0 ? 'center' : _param_alignment, label = param.label, sublabel = param.sublabel, title = param.title, description = param.description, actions = param.actions, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? '--colors-green-700' : _param_accentColor, className = param.className;
    var containerRef = useRef(null);
    var hoverAccentColor = accentColor.startsWith('--colors-') ? changeColorVariableWeight(accentColor, function(value) {
        return value + 200;
    }) : accentColor;
    var accentStyle = useAccentColors([
        'colors-article-hero-accent',
        accentColor
    ], [
        'colors-button-main-bg-base',
        accentColor
    ], [
        'colors-button-main-bg-hover',
        hoverAccentColor
    ], [
        'colors-button-bordered-fg-base',
        accentColor
    ], [
        'colors-button-bordered-border-base',
        accentColor
    ], [
        'colors-button-bordered-border-hover',
        hoverAccentColor
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: ArticleHero.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        style: accentStyle,
        className: "flex flex-col items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('w-full max-w-md text-center md:text-left', alignment === 'center' && 'md:text-center')
    }, !!label && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 font-heading font-semibold uppercase text-body-small text-[var(--colors-article-hero-accent)]"
    }, label)), /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h2",
        className: twMerge(alignment === 'left' && 'md:text-heading-h2-desktop-s')
    }, title)), !!sublabel && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Label, {
        className: "mt-5 text-[var(--colors-article-hero-accent)]"
    }, sublabel)), !!(actions === null || actions === void 0 ? void 0 : actions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex items-center -m-2', alignment === 'center' && 'justify-center', alignment === 'left' && 'justify-center md:justify-start')
    }, actions.map(function(action, actionIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "articlehero-action-".concat(action.href),
            view: containerRef,
            delay: (actionIndex + 1) / 5
        }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
            className: "m-2",
            label: /*#__PURE__*/ React.createElement("span", {
                className: "flex items-center"
            }, /*#__PURE__*/ React.createElement("span", null, action.label), !!action.suffix && /*#__PURE__*/ React.createElement("span", {
                className: "ml-3 font-normal text-navigation-small"
            }, action.suffix))
        })));
    })))), !!description && /*#__PURE__*/ React.createElement("div", {
        className: twMerge('w-full max-w-sm mt-6 text-center md:mt-7 md:text-left', alignment === 'center' && 'md:text-center')
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.15
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description)))));
}

//# sourceMappingURL=ArticleHero.js.map